import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { CircleCheckBig, CircleX, X } from 'lucide-react';
import { removeToast } from '../../Redux/CommonSlice/toastSlice';


const Toast = ({ id, isError = false, message = 'Vehicle Entered Successfully' }) => {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setShow(true);
    const timer = setTimeout(() => {
      setShow(false);
      setTimeout(() => {
        dispatch(removeToast(id));
      }, 300);
    }, 5000);

    return () => clearTimeout(timer);
  }, [dispatch, id]);

  return (
    <div
      className={`flex items-center justify-between bg-white rounded-[10px] ${
        isError ? 'border-dangerColor' : 'border-primaryColor'
      } border-l-[8px] gap-2 pl-2 pr-2 pt-[2px] pb-[2px] min-h-[50px] transform transition-all duration-300 ${
        show ? 'translate-x-0 opacity-100' : 'translate-x-10 opacity-0'
      }`}
    >
      <div
        className={`w-[40px] h-[40px] rounded-full ${
          isError ? 'bg-dangerColor' : 'bg-primaryColor'
        } grid place-items-center text-white`}
      >
        {isError ? <CircleX /> : <CircleCheckBig />}
      </div>
      <h3 className="m-0 font-bold text-[16px] flex-grow py-1">{message}</h3>

      <div className="w-[50px] border-l min-h-[50px] flex items-center justify-center">
        <X className="cursor-pointer" onClick={() => dispatch(removeToast(id))} />
      </div>
    </div>
  );
};

export default Toast;